import React from 'react'

const Testimonal = () => {
  return (
    <div>
      testimonals
      
    </div>
  )
}

export default Testimonal
